import LendingPage from 'screens/Contract/Lending/Lending';

export default LendingPage;
